<div class="row mb-3">
    <div class="col-auto">
        <div class="border rounded px-3 py-2">
            <div class="kt-font-bold kt-font-lg">{{ membersCount | number : '1.0' }}</div>
            <small class="text-muted">Assigned</small>
        </div>
    </div>
    <div class="col-auto">
        <div class="border rounded px-3 py-2">
            <div class="kt-font-bold kt-font-lg kt-font-success">+{{ stagedAdd.size | number : '1.0' }}</div>
            <small class="text-muted">To add on save</small>
        </div>
    </div>
    <div class="col-auto">
        <div class="border rounded px-3 py-2">
            <div class="kt-font-bold kt-font-lg kt-font-danger">−{{ stagedRemove.size | number : '1.0' }}</div>
            <small class="text-muted">To remove on save</small>
        </div>
    </div>
</div>

<div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
    <div class="d-flex align-items-center">
        <input type="text" class="form-control username-filter mr-2" placeholder="Username" [(ngModel)]="username"
            [ngModelOptions]="{standalone: true}" (keyup.enter)="onSearch()">
        <kt-search-button [loading]="loading" [disabledButton]="loading" (search)="onSearch()"></kt-search-button>
        <kt-clear-button [loading]="loading" [disabledButton]="loading" (clear)="onClear()"></kt-clear-button>
    </div>
    <div *ngIf="!readonly">
        <button type="button" class="btn btn-outline-danger btn-sm mr-2" [disabled]="selected.size === 0" (click)="onRemoveSelected()">
            <i class="fas fa-user-minus"></i>Remove Selected ({{ selected.size }})
        </button>
        <button type="button" class="btn btn-brand btn-sm" [disabled]="!provider" (click)="onAddPlayers()">
            <i class="fas fa-plus"></i>Add Players
        </button>
    </div>
</div>

<div class="table-responsive">
    <table class="table table-bordered table-hover table-striped">
        <thead>
            <tr>
                <th *ngIf="!readonly" class="text-center">
                    <input type="checkbox" [checked]="allSelected" (change)="onToggleAll($event.target.checked)">
                </th>
                <th>ID</th>
                <th>Username</th>
                <th class="text-center">Currency</th>
                <th>Member Group</th>
                <th>Added By</th>
                <th *ngIf="!readonly" class="text-center">Action</th>
            </tr>
        </thead>
        <tbody *ngIf="!loading">
            <tr *ngFor="let row of rows; trackBy: trackByRow" [class.text-muted]="row.staged === 'remove'">
                <td *ngIf="!readonly" class="text-center">
                    <input type="checkbox" [checked]="selected.has(row.id)" (change)="onToggle(row, $event.target.checked)">
                </td>
                <td>{{ row.id }}</td>
                <td>
                    <s *ngIf="row.staged === 'remove'; else plainName">{{ row.username }}</s>
                    <ng-template #plainName>{{ row.username }}</ng-template>
                </td>
                <td class="text-center">{{ row.currency_code }}</td>
                <td>{{ row.member_group || '-' }}</td>
                <td>{{ row.added_by || '-' }}</td>
                <td *ngIf="!readonly" class="text-center">
                    <button type="button" class="btn btn-outline-hover-danger btn-elevate btn-sm btn-icon btn-icon-sm"
                        [matTooltip]="row.staged === 'remove' ? 'Keep this player' : 'Remove'" (click)="onRemove(row)">
                        <i [class]="row.staged === 'remove' ? 'fas fa-undo' : 'fas fa-trash-alt'"></i>
                    </button>
                </td>
            </tr>
        </tbody>
        <tbody shared-table-handler [loading]="loading" [dataLength]="rows.length"></tbody>
    </table>
</div>

<div class="kt-pagination kt-pagination--brand mt-2" *ngIf="totalPages > 1">
    <ngb-pagination [pageSize]="pageSize" [page]="page" [maxSize]="maxSize" [directionLinks]="true"
        [boundaryLinks]="true" [rotate]="true" [collectionSize]="totalPages * pageSize" (pageChange)="load($event)">
    </ngb-pagination>
    <div class="kt-pagination__toolbar">
        <span class="pagination__desc">{{ pageDescription }}</span>
    </div>
</div>
